export default {
  sm: `
  미래를 담은
  데이터센터 각
  `
};
